import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "../../app";
import { wavemindIcon } from "../../utils/icons";

@customElement("admin-nav")
export class AdminNav extends BaseElement {
    render() {
        const path = location.pathname;
        return html`
            <nav class="bg-white shadow mb-6">
                <div class="max-w-7xl mx-auto px-4">
                    <div class="flex h-12 items-center">
                        <a href="/" class="flex-shrink-0 flex items-center w-8 h-8 text-blue-600"> ${wavemindIcon} </a>
                        <div class="flex overflow-x-auto whitespace-nowrap">
                            <a
                                href="/admin"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                Dashboard
                            </a>
                            <a
                                href="/admin/users"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin/users"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                Users
                            </a>
                            <a
                                href="/admin/searches"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin/searches"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                Searches
                            </a>
                            <a
                                href="/admin/completions"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin/completions"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                Completions
                            </a>
                            <a
                                href="/admin/chats"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin/chats"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                Chats
                            </a>
                            <a
                                href="/admin/sql"
                                class="inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${path === "/admin/sql"
                                    ? "border-blue-500 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"}"
                            >
                                SQL Console
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        `;
    }
}
